import React from 'react'
import { Box, Flex, Divider } from '@chilipiper/design-system'
import { IconButton } from '@chilipiper/design-system/src/new'
import { SvgRemove } from '@chilipiper/icons/src/design-system'
import { SvgRepeatingEvent } from '@chilipiper/icons'
import { motion } from 'framer-motion'
import { StyledAvatarImage } from '../styles'
import { ThemedText } from '../themed-components/themedComponents'

const HORIZONTAL_PADDING = 6

interface Props {
  avatars: string[]
  hasDivider?: boolean
  isDividerFullWidth?: boolean
  name: string
  onClose?: () => void
  onRestart?: () => void
  showRestart: boolean
}

export const Header = ({
  avatars,
  name,
  isDividerFullWidth = false,
  onClose,
  hasDivider = true,
  showRestart,
  onRestart,
}: Props) => (
  <Box flex={1}>
    <Flex alignItems='center' justifyContent='space-between' py={4} px={HORIZONTAL_PADDING}>
      <Flex alignItems='center'>
        {avatars.map((avatar, index) => (
          <Flex key={avatar} ml={index === 0 ? 0 : -3}>
            <StyledAvatarImage src={avatar} alt='' borderWidth={index === 0 ? '0' : '2px'} />
          </Flex>
        ))}
        <ThemedText
          color='text/body-major'
          fontWeight={500}
          px={3}
          lineHeight={4}
          data-test-id='WidgetHeader-name'
        >
          {name}
        </ThemedText>
      </Flex>
      <Flex alignItems='center' gap={2}>
        {showRestart && onRestart && (
          <IconButton
            size={7}
            label='Start over'
            icon={SvgRepeatingEvent}
            onClick={onRestart}
            data-test-id='WidgetHeader-restart'
            variant='ghost'
          />
        )}
        <IconButton
          size={7}
          label='Close chat'
          icon={SvgRemove}
          onClick={onClose}
          data-test-id='WidgetHeader-close'
          variant='ghost'
        />
      </Flex>
    </Flex>
    {hasDivider && (
      <AnimatedThemedDivider layout mx={isDividerFullWidth ? 0 : HORIZONTAL_PADDING} />
    )}
  </Box>
)

const AnimatedThemedDivider = motion(Divider)
